import {
	Box,
	Container,
	Flex,
	Heading,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";
import React from "react";

const AlternateCapitalBlog: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Unlocking India&apos;s Alternate Capital Landscape: A Recap of IVCA’s
					#AltCap101
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						The dynamic world of alternate capital is a rapidly growing force in
						India’s financial ecosystem. To help fund managers stay ahead of the
						curve, IVCA (Indian Venture and Alternate Capital Association)
						launched its flagship knowledge-sharing initiative, #AltCap101, on
						October 17, 2024, in Mumbai. This advanced learning platform,
						organized in collaboration with IC Universal Legal and EY India,
						gathered some of the brightest minds in private equity, venture
						capital, and institutional investing.
					</Text>
					<Img
						src="https://static.levocdn.com/WGLBUT82/Screenshot2024-10-29at33847PM-fF95WePe02Cr.png"
						alt="Group"
						width="500px"
						objectFit="contain"
						mx="auto"
						my="22px"
					/>
					<Text fontSize="14px" textAlign="center" variant="blogAnswer">
						(L-R: Rajat Tandon, President, IVCA; Smt. Nivruti Rai, MD & CEO of
						Invest India; Ashley Menezes, Chairperson of IVCA and Partner & COO
						at ChrysCapital Advisors LLP.)
					</Text>
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Text variant="blogAnswer" pt="8px">
						Building on the success of #VC101 from last year, #AltCap101 has
						become a premier knowledge-sharing programme designed to provide
						fund managers with the insights needed to navigate the evolving
						alternate capital landscape. Whether it’s exploring new
						opportunities or understanding global market shifts, this event was
						crafted to equip decision-makers with the tools necessary to succeed
						in a rapidly transforming sector.
						<br />
						<br />
						But why now? What makes this moment pivotal for the industry?
						Let&apos;s dive into the takeaways from the event and the compelling
						discussions that unfolded. for us:
						<br />
						<br />
					</Text>
				</Box>
				<Box display="flex" alignItems="start" gap="32px" my="16px">
					<Img
						src="https://static.levocdn.com/WGLBUT82/Nivruti-Bwj3oGkG7dx4.jpeg"
						alt="Group"
						width="300px"
						objectFit="contain"
						mx="auto"
						my="22px"
					/>
					<div>
						<Heading variant="blogQuestion" pb="20px" pt="12px">
							India’s Global Investment Appeal: The Fireside Chat with Nivruti
							Rai and Ashley Menezes
						</Heading>

						<Text variant="blogAnswer" pt="8px">
							The highlight of the day was a captivating fireside chat featuring
							Smt. Nivruti Rai, MD & CEO of Invest India, and Ashley Menezes,
							Chairperson of IVCA and Partner & COO at ChrysCapital Advisors
							LLP. Titled "India Opportunity," the conversation revolved around
							India’s rise as a global investment destination and the role of
							alternate capital in fueling this growth.
							<br />
							<br />
							According to Smt. Rai, India is in a prime position, contributing
							to 16% of the world’s growth and responsible for 30% of the
							increase in global patent filings in 2022. For fund managers and
							global investors, this is a clear signal that India is a
							powerhouse of innovation and potential. Rai emphasized the
							country’s focus on sectors such as renewable energy, green
							technology, and infrastructure as pivotal for sustainable growth.
							With initiatives like the Emerging Asia Manufacturing Index 2024
							ranking India as a top hub for workforce and economic potential,
							it’s no wonder that global investors are keeping a close eye on
							the country.
						</Text>
					</div>
				</Box>
				<Box
					display="flex"
					flexDirection="row-reverse"
					alignItems="start"
					gap="32px"
					my="28px"
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/Ashley-n3qCfljl4bAL.jpg"
						alt="Group"
						width="300px"
						objectFit="contain"
						mx="auto"
						my="22px"
					/>
					<div>
						<Text variant="blogAnswer" pt="8px">
							Ashley Menezes echoed this sentiment, highlighting how India’s
							ease of doing business ranking has shot up from 142nd to 33rd in
							just a decade. For alternate capital investors, India presents an
							unparalleled combination of strong macroeconomic fundamentals,
							strategic reforms, and a government willing to foster private
							sector growth.
							<br />
							<br />
							India’s macroeconomic fundamentals are strong, and its
							attractiveness as an alternate capital destination is only
							increasing, Menezes remarked. He pointed out that institutions
							like Invest India have facilitated smoother conversations between
							the government and private sector, providing fund managers with a
							clearer pathway to success in India’s growing markets.
						</Text>
					</div>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						The Evolution of India’s Alternate Capital Market
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						A key theme that resonated throughout the discussions was how
						India’s alternate capital market has transformed in recent years. As
						India’s private capital assets under management (AUM) tripled over
						the last decade to reach $124.3 billion by the end of 2023, there is
						no denying the growing significance of venture capital, private
						equity, and other alternative investments in the country.
						<br />
						<br />
						#AltCap101 provided fund managers with an opportunity to discuss
						pressing questions: What’s next for the industry? How do we keep up
						with global market shifts? The programme delivered key insights into
						these questions, making it an essential touchpoint for senior
						management teams from venture capital firms, private equity funds,
						family offices, and institutional investors.
					</Text>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						Looking Ahead: The Roadmap for Alternate Capital
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						As we move forward, the global economic landscape will continue to
						evolve, and India is poised to be at the heart of these shifts. Fund
						managers attending #AltCap101 walked away with not just a wealth of
						knowledge but also an understanding of the broader global trends
						impacting alternate capital. By focusing on long-term sustainability
						and innovation, the future looks bright for India’s growing role in
						the world of alternate investments.
						<br />
						<br />
						For those looking to engage with India’s vibrant financial
						ecosystem, IVCA will continue to provide the platforms, insights,
						and community necessary to stay ahead of the curve.
						<br />
						<br />
						Stay tuned for more programmes like #AltCap101 as IVCA continues its
						mission to build a robust, future-ready alternate capital ecosystem
						in India.
					</Text>
				</Box>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default AlternateCapitalBlog;
